<template>
  <div>
    <!-- 접속자 -->
    <div class="mr-b25" v-show="!isEmpty(clientSnapshotData.snapshotDoc)">
      <el-row type="flex" class="title-bar" justify="space-between">
        <div>
          <span class="tit content-title">접속자</span>
          <span class="condition-text">({{ clientSnapshotDateLabel }})</span>
        </div>
        <w-header-search-button size="mini" @click="showClientSearchTool = !showClientSearchTool"></w-header-search-button>
      </el-row>
      <w-ap-client-table :data="clientSnapshotData.snapshotDoc" :show-search-tool="showClientSearchTool" :obj-company-id="data.obj ? data.obj.objCompanyId : null" />
    </div>
  </div>
</template>

<script>
import { isNil, isEmpty } from 'lodash';
import { isTrue } from '@/utils/boolean';
import { EMPTY_TEXT } from '@/utils/string';
import WApClientTable from '@/views/performance/components/wireless/ApClientTable';
import { etcInfoDefine } from '../../../constants/fault-analysis';
import { getDateLabel } from '../../../utils/fault-analysis';

export default {
  name: 'WWirelessApEtcInfoView',
  components: {
    WApClientTable,
  },
  props: {
    /**
     * 기타 분석 정보 조회 시 필요한 정보 객체 (동시성 문제 고려하여 하나의 객체로 전달)
     * 1) obj: 분석 대상 장비 정보
     * 2) eventHistData: 분석 이벤트 이력 정보
     * 3) etcInfo: 기타 분석 정보
     * @type {Object}
     */
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      /* 무선 AP */
      showClientSearchTool: false,
      clientSnapshotData: {},
    };
  },
  computed: {
    /**
     * 접속자 스냅샷 일시 라벨
     * @author Ju
     * @return {String}
     */
    clientSnapshotDateLabel() {
      return isNil(this.clientSnapshotData.timestamp) ? EMPTY_TEXT : getDateLabel(this.clientSnapshotData.timestamp);
    },
  },
  watch: {
    data: {
      immediate: true,
      handler(to) {
        this.reset();
        if (!isNil(to)) {
          this.loadData();
        }
      },
    },
  },
  methods: {
    isEmpty,
    isTrue,
    /**
     * 무선 AP 기타 분석 정보 조회
     * @author Ju
     */
    loadData() {
      this.setClientSnapshotData();
    },
    /**
     * 화면을 초기화한다.
     * @author Ju
     */
    reset() {
      // 접속자 스냅샷
      this.clientSnapshotData = {};
    },
    /**
     * 접속자 스냅샷 정보를 설정한다.
     * @author Ju
     */
    setClientSnapshotData() {
      if (!isEmpty(this.data.etcInfo) && !isEmpty(this.data.etcInfo[etcInfoDefine.WIRELESS_AP_CLIENT])) {
        this.clientSnapshotData = this.data.etcInfo[etcInfoDefine.WIRELESS_AP_CLIENT];
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/popup/FaultAnalysisPopup/components/FaultAnalysisInfoView/EtcInfo/WirelessApEtcInfoView.vue